import translations from './translations';

// When making new constants please follow https://github.com/airbnb/javascript#naming--uppercase
// Why: UPPERCASE_VARIABLES are letting the programmer know that they can trust the variable (and its properties) not to change.
// Rule: Uppercase at the top level of export (e.g. EXPORTED_OBJECT.key) and maintain that all nested properties do not change.
//
// bad
// export const mapping = {
//     KEY: 'VALUE'
// };
//
// good
// export const MAPPING = {
//     key: 'value'
// };

const env = document.querySelector('meta[name="env"]').getAttribute('content');

export const ENV = env === '${ENVIRONMENT}' || env === '' ? null : env; // ensure the ${ENVIRONMENT} template marker never gets used
export const ENGINE_API_URL = document
    .querySelector('meta[name="engine-api-url"]')
    .getAttribute('content');
export const ADMIN_ASSET_URL = document
    .querySelector('meta[name="admin-asset-url"]')
    .getAttribute('content');

export const OKTA_ENABLED = document
    .querySelector('meta[name="okta-enabled"]')
    .getAttribute('content');
export const OKTA_BASE_URL = document
    .querySelector('meta[name="okta-base-url"]')
    .getAttribute('content');
export const OKTA_CLIENT_ID = document
    .querySelector('meta[name="okta-client-id"]')
    .getAttribute('content');

export const ALWAYS_OPEN_NEW_TAB = ['build', 'players', 'macros'];

export const AUTHENTICATION_TYPES = [
    { value: 'PUBLIC', label: 'Anyone can run this flow' },
    {
        value: 'ALL_USERS',
        label: 'Any user that can login with the selected identity service can run this flow',
    },
    { value: 'SPECIFIED', label: 'Create restrictions for specific users and groups of users' },
];

export const SOCIAL_STREAM = [
    { value: 'NONE', label: 'None' },
    { value: 'USE_EXISTING', label: 'Display a social feed' },
];

// These will need to be hard-coded until roles are surfaced by the API
export const SYSTEM_ROLES = {
    administrator: {
        roleId: 1,
        developerName: 'ADMINISTRATOR',
        friendlyName: 'Administrator',
    },
    standard_user: {
        roleId: 2,
        developerName: 'STANDARD_USER',
        friendlyName: 'Standard User',
    },
    service_user: {
        roleId: 3,
        developerName: 'SERVICE_USER',
        friendlyName: 'Service User',
    },
};

export const MAP_ELEMENT_TYPES = {
    start: 'start',
    input: 'input',
    step: 'step',
    decision: 'decision',
    operator: 'operator',
    message: 'message',
    database_load: 'database_load',
    database_save: 'database_save',
    database_delete: 'database_delete',
    swimlane: 'swimlane',
    subflow: 'subflow',
    return: 'return',
    group: 'group',
    note: 'note',
    outcome: 'outcome',
};

export const HOSTS = {
    federal: 'federal.flow.boomi.com',
};

export const SERVICE_FEATURES = {
    providesAutoBinding: 'providesAutoBinding',
    providesDatabase: 'providesDatabase',
    providesFiles: 'providesFiles',
    providesIdentity: 'providesIdentity',
    providesLocation: 'providesLocation',
    providesLogic: 'providesLogic',
    providesSocial: 'providesSocial',
    providesViews: 'providesViews',
};

export const USER_NOTIFICATION_TYPE = {
    deleteAll: 'delete_all',
    deleteTenant: 'delete_tenant',
    fault: 'fault',
    passwordReset: 'password_reset',
    tenantCreation: 'tenant_creation',
    provisioning: 'provisioning',
    warning: 'warning',
    release: 'release',
};

export const MAX_PAGE_LIMIT = 250;

export const APP_LINKS = {
    integration: 'https://platform.boomi.com/AtomSphere.html',
    datahub: 'https://platform.boomi.com/MdmSphere.html',
    apimgnt: 'https://platform.boomi.com/ApiSphere.html',
};

export const HELP_LINKS = {
    docs: 'https://help.boomi.com/category/flow',
    support: 'https://community.boomi.com/s/support',
    community: 'https://community.boomi.com/s/topic/0TO1W000000cffIWAQ/flow',
    training: 'https://train.boomi.com/',
};

export const EMAILS = {
    support: 'support@boomi.com',
};

export const direction = {
    NONE: null,
    ASC: 'asc',
    DESC: 'desc',
};

export const systemValues = {
    TRUE: {
        developerName: '$True',
        id: 'be1bc78e-fd57-40ec-9a86-a815de2a9e28',
    },
    FALSE: {
        developerName: '$False',
        id: '496fd041-d91f-48fb-aa4f-91c6c9a11ca1',
    },
};

export const keyCodes = {
    ENTER: 13,
    DELETE: 46,
    G: 71,
    ESCAPE: 27,
};

export const conditionTypes = [
    { key: 'Visible', value: 'METADATA.VISIBLE' },
    { key: 'Required', value: 'METADATA.REQUIRED' },
    { key: 'Enabled', value: 'METADATA.ENABLED' },
];

export const stateStatus = {
    IN_PROGRESS: 'in_progress',
    DONE: 'done',
    EXPIRED: 'expired',
    ERRORED: 'errored',
};

export const timeFilter = {
    LAST_YEAR: 0,
    LAST_30_DAYS: 1,
    LAST_7_DAYS: 2,
    LAST_24_HOURS: 3,
};

export const timeInterval = {
    LAST_YEAR: 'year',
    LAST_30_DAYS: 'month',
    LAST_7_DAYS: 'week',
    LAST_24_HOURS: 'day',
};

export const FLOW_SORT_COLUMNS = {
    NAME_ASC: 0,
    NAME_DESC: 1,
    LAST_MODIFIELD_ASC: 2,
    LAST_MODIFIELD_DESC: 3,
};

export const seriesColours = [
    '#0C457A',
    '#B4315C',
    '#EC672B',
    '#47ACAD',
    '#147CB4',
];

export const timeUnits = {
    hourly: 'hour',
    daily: 'day',
    monthly: 'month',
};

export const pageConditionsBoilerplate = {
    comparisonType: 'AND',
    generatedSummary: null,
    pageOperations: [
        {
            assignment: {
                assignee: {
                    metadataType: null,
                    pageObjectReferenceDeveloperName: null,
                    pageObjectReferenceId: null,
                    typeElementPropertyId: null,
                    valueElementToReferenceId: null,
                },
                assignor: {
                    metadataType: 'VALUE',
                    pageObjectReferenceDeveloperName: null,
                    pageObjectReferenceId: null,
                    typeElementPropertyId: null,
                    valueElementToReferenceId: {
                        command: null,
                        id: null,
                        typeElementPropertyId: null,
                    },
                },
            },
            filter: null,
            generatedSummary: null,
        },
    ],
    pageRules: [
        {
            criteriaType: 'EQUAL',
            generatedSummary: null,
            left: {
                metadataType: 'VALUE',
                pageObjectReferenceDeveloperName: null,
                pageObjectReferenceId: null,
                typeElementPropertyId: null,
                valueElementToReferenceId: null,
            },
            right: {
                metadataType: 'VALUE',
                pageObjectReferenceDeveloperName: null,
                pageObjectReferenceId: null,
                typeElementPropertyId: null,
                valueElementToReferenceId: {
                    command: null,
                    id: null,
                    typeElementPropertyId: null,
                },
            },
        },
    ],
};

export const flowLaunchesChartOptions = {
    layout: {
        padding: {
            bottom: 30,
        },
    },
    tooltips: {
        mode: 'index',
        intersect: false,
        callbacks: {
            label: (tooltipItem) => `${tooltipItem.yLabel} flow launches`,
        },
    },
    responsive: true,
    scales: {
        yAxes: [
            {
                ticks: {
                    callback: (value) => (Number.isInteger(value) ? value : null), // just show integer ticks
                },
            },
        ],
    },
    legend: {
        position: 'left',
    },
};

export const ACCESS_LEVELS = {
    PRIVATE: {
        value: 'PRIVATE',
        label: `Private - ${translations.AV_private_access_value}`,
        labelShort: 'Private',
        description: translations.AV_private_access_value,
    },
    INPUT: {
        value: 'INPUT',
        label: `Input - ${translations.AV_input_access_value}`,
        labelShort: 'Input',
        description: translations.AV_input_access_value,
    },
    OUTPUT: {
        value: 'OUTPUT',
        label: `Output - ${translations.AV_output_access_value}`,
        labelShort: 'Output',
        description: translations.AV_output_access_value,
    },
    INPUT_OUTPUT: {
        value: 'INPUT_OUTPUT',
        label: `Input & Output - ${translations.AV_input_output_access_value}`,
        labelShort: 'Input & Output',
        description: translations.AV_input_output_access_value,
    },
    PUBLIC: {
        value: 'PUBLIC',
        label: `Public - ${translations.AV_public_access_value}`,
        labelShort: 'Public',
        description: translations.AV_public_access_value,
    },
};

export const contentTypesList = [
    { key: 'CONTENTSTRING', label: 'String' },
    { key: 'CONTENTNUMBER', label: 'Number' },
    { key: 'CONTENTBOOLEAN', label: 'Boolean' },
    { key: 'CONTENTPASSWORD', label: 'Password' },
    { key: 'CONTENTENCRYPTED', label: 'Encrypted' },
    { key: 'CONTENTDATETIME', label: 'DateTime' },
    { key: 'CONTENTCONTENT', label: 'Content' },
    { key: 'CONTENTOBJECT', label: 'Object' },
    { key: 'CONTENTLIST', label: 'List' },
];

export const contentTypes = contentTypesList.reduce((accumulator, currentType) => {
    accumulator[currentType.label.toLowerCase()] = currentType.key;
    return accumulator;
}, {});

export const OPERATION_COMMANDS = {
    valueOf: {
        command: 'VALUE_OF',
        display: 'Value Of',
        contentTypes: [
            contentTypes.string,
            contentTypes.password,
            contentTypes.content,
            contentTypes.encrypted,
            contentTypes.number,
            contentTypes.datetime,
            contentTypes.boolean,
            contentTypes.list,
            contentTypes.object,
        ],
    },
    getLength: {
        command: 'GET_LENGTH',
        display: 'Length Of',
        contentTypes: [
            contentTypes.list,
            contentTypes.string,
            contentTypes.password,
            contentTypes.content,
            contentTypes.encrypted,
        ],
    },
    getFirst: {
        command: 'GET_FIRST',
        display: 'First Record Of',
        contentTypes: [contentTypes.list],
    },
    getNext: {
        command: 'GET_NEXT',
        display: 'Next Record Of',
        contentTypes: [contentTypes.list],
    },
    setEqual: {
        command: 'SET_EQUAL',
        display: 'Set Equal To',
        contentTypes: [
            contentTypes.string,
            contentTypes.password,
            contentTypes.content,
            contentTypes.encrypted,
            contentTypes.number,
            contentTypes.datetime,
            contentTypes.boolean,
            contentTypes.list,
            contentTypes.object,
        ],
    },
    // Not yet supported - requires additional criteria
    filter: {
        command: 'FILTER',
        display: 'Filter',
    },
    remove: {
        command: 'REMOVE',
        display: 'Remove',
        contentTypes: [contentTypes.list, contentTypes.object],
    },
    update: {
        command: 'ADD',
        display: 'Update',
        contentTypes: [contentTypes.list, contentTypes.object],
    },
    add: {
        command: 'ADD',
        display: 'Add',
        contentTypes: [contentTypes.number],
    },
    subtract: {
        command: 'REMOVE',
        display: 'Subtract',
        contentTypes: [contentTypes.number],
    },
    divide: {
        command: 'DIVIDE',
        display: 'Divide',
        contentTypes: [contentTypes.number],
    },
    multiply: {
        command: 'MULTIPLY',
        display: 'Multiply',
        contentTypes: [contentTypes.number],
    },
    modulo: {
        command: 'MODULO',
        display: 'Modulo',
        contentTypes: [contentTypes.number],
    },
    join: {
        command: 'ADD',
        display: 'Join',
        contentTypes: [
            contentTypes.string,
            contentTypes.password,
            contentTypes.content,
            contentTypes.encrypted,
        ],
    },
    new: {
        command: 'NEW',
        display: 'Create New',
        contentTypes: [
            contentTypes.string,
            contentTypes.password,
            contentTypes.content,
            contentTypes.encrypted,
            contentTypes.number,
            contentTypes.datetime,
            contentTypes.boolean,
            contentTypes.list,
            contentTypes.object,
        ],
    },
    empty: {
        command: 'EMPTY',
        display: 'Empty',
        contentTypes: [
            contentTypes.string,
            contentTypes.password,
            contentTypes.content,
            contentTypes.encrypted,
            contentTypes.number,
            contentTypes.datetime,
            contentTypes.boolean,
            contentTypes.list,
            contentTypes.object,
        ],
    },
    sort: {
        command: 'SORT',
        display: 'Sort',
        contentTypes: [contentTypes.list],
    },
};

export const notificationTypes = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    INFO: 'info',
};

export const REGIONAL_INSTANCE_LIST = [
    { code: 'US', name: 'North Virginia (US)' },
    { code: 'GB', name: 'London (GB)' },
    { code: 'AU', name: 'Sydney (AU)' },
    { code: 'CA', name: 'Canada (CA)' },
    { code: 'SG', name: 'Singapore (SG)' },
];

export const CONTINENT_LIST = [
    { code: 'AF', name: 'Africa' },
    { code: 'AN', name: 'Antarctica' },
    { code: 'AS', name: 'Asia' },
    { code: 'EU', name: 'Europe' },
    { code: 'NA', name: 'North america' },
    { code: 'OC', name: 'Oceania' },
    { code: 'SA', name: 'South america' },
];

export const ISO_ALPHA_2_COUNTRY_LIST = [
    { code: 'AF', name: 'Afghanistan' },
    { code: 'AX', name: '\u00c5land Islands' },
    { code: 'AL', name: 'Albania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AD', name: 'Andorra' },
    { code: 'AO', name: 'Angola' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'AQ', name: 'Antarctica' },
    { code: 'AG', name: 'Antigua and Barbuda' },
    { code: 'AR', name: 'Argentina' },
    { code: 'AM', name: 'Armenia' },
    { code: 'AW', name: 'Aruba' },
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'AZ', name: 'Azerbaijan' },
    { code: 'BS', name: 'Bahamas' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'BD', name: 'Bangladesh' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BY', name: 'Belarus' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BZ', name: 'Belize' },
    { code: 'BJ', name: 'Benin' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'BT', name: 'Bhutan' },
    { code: 'BO', name: 'Bolivia, Plurinational State of' },
    { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
    { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Botswana' },
    { code: 'BV', name: 'Bouvet Island' },
    { code: 'BR', name: 'Brazil' },
    { code: 'IO', name: 'British Indian Ocean Territory' },
    { code: 'BN', name: 'Brunei Darussalam' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'BI', name: 'Burundi' },
    { code: 'KH', name: 'Cambodia' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'CA', name: 'Canada' },
    { code: 'CV', name: 'Cape Verde' },
    { code: 'KY', name: 'Cayman Islands' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' },
    { code: 'CL', name: 'Chile' },
    { code: 'CN', name: 'China' },
    { code: 'CX', name: 'Christmas Island' },
    { code: 'CC', name: 'Cocos (Keeling) Islands' },
    { code: 'CO', name: 'Colombia' },
    { code: 'KM', name: 'Comoros' },
    { code: 'CG', name: 'Congo' },
    { code: 'CD', name: 'Congo, the Democratic Republic of the' },
    { code: 'CK', name: 'Cook Islands' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'CI', name: "C\u00f4te d'Ivoire" },
    { code: 'HR', name: 'Croatia' },
    { code: 'CU', name: 'Cuba' },
    { code: 'CW', name: 'Cura\u00e7ao' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DK', name: 'Denmark' },
    { code: 'DJ', name: 'Djibouti' },
    { code: 'DM', name: 'Dominica' },
    { code: 'DO', name: 'Dominican Republic' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'EG', name: 'Egypt' },
    { code: 'SV', name: 'El Salvador' },
    { code: 'GQ', name: 'Equatorial Guinea' },
    { code: 'ER', name: 'Eritrea' },
    { code: 'EE', name: 'Estonia' },
    { code: 'ET', name: 'Ethiopia' },
    { code: 'FK', name: 'Falkland Islands (Malvinas)' },
    { code: 'FO', name: 'Faroe Islands' },
    { code: 'FJ', name: 'Fiji' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'GF', name: 'French Guiana' },
    { code: 'PF', name: 'French Polynesia' },
    { code: 'TF', name: 'French Southern Territories' },
    { code: 'GA', name: 'Gabon' },
    { code: 'GM', name: 'Gambia' },
    { code: 'GE', name: 'Georgia' },
    { code: 'DE', name: 'Germany' },
    { code: 'GH', name: 'Ghana' },
    { code: 'GI', name: 'Gibraltar' },
    { code: 'GR', name: 'Greece' },
    { code: 'GL', name: 'Greenland' },
    { code: 'GD', name: 'Grenada' },
    { code: 'GP', name: 'Guadeloupe' },
    { code: 'GU', name: 'Guam' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'GG', name: 'Guernsey' },
    { code: 'GN', name: 'Guinea' },
    { code: 'GW', name: 'Guinea-Bissau' },
    { code: 'GY', name: 'Guyana' },
    { code: 'HT', name: 'Haiti' },
    { code: 'HM', name: 'Heard Island and McDonald Islands' },
    { code: 'VA', name: 'Holy See (Vatican City State)' },
    { code: 'HN', name: 'Honduras' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IS', name: 'Iceland' },
    { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IR', name: 'Iran, Islamic Republic of' },
    { code: 'IQ', name: 'Iraq' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IM', name: 'Isle of Man' },
    { code: 'IL', name: 'Israel' },
    { code: 'IT', name: 'Italy' },
    { code: 'JM', name: 'Jamaica' },
    { code: 'JP', name: 'Japan' },
    { code: 'JE', name: 'Jersey' },
    { code: 'JO', name: 'Jordan' },
    { code: 'KZ', name: 'Kazakhstan' },
    { code: 'KE', name: 'Kenya' },
    { code: 'KI', name: 'Kiribati' },
    { code: 'KP', name: "Korea, Democratic People's Republic of" },
    { code: 'KR', name: 'Korea, Republic of' },
    { code: 'KW', name: 'Kuwait' },
    { code: 'KG', name: 'Kyrgyzstan' },
    { code: 'LA', name: "Lao People's Democratic Republic" },
    { code: 'LV', name: 'Latvia' },
    { code: 'LB', name: 'Lebanon' },
    { code: 'LS', name: 'Lesotho' },
    { code: 'LR', name: 'Liberia' },
    { code: 'LY', name: 'Libya' },
    { code: 'LI', name: 'Liechtenstein' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MO', name: 'Macao' },
    { code: 'MK', name: 'Macedonia, the Former Yugoslav Republic of' },
    { code: 'MG', name: 'Madagascar' },
    { code: 'MW', name: 'Malawi' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'MV', name: 'Maldives' },
    { code: 'ML', name: 'Mali' },
    { code: 'MT', name: 'Malta' },
    { code: 'MH', name: 'Marshall Islands' },
    { code: 'MQ', name: 'Martinique' },
    { code: 'MR', name: 'Mauritania' },
    { code: 'MU', name: 'Mauritius' },
    { code: 'YT', name: 'Mayotte' },
    { code: 'MX', name: 'Mexico' },
    { code: 'FM', name: 'Micronesia, Federated States of' },
    { code: 'MD', name: 'Moldova, Republic of' },
    { code: 'MC', name: 'Monaco' },
    { code: 'MN', name: 'Mongolia' },
    { code: 'ME', name: 'Montenegro' },
    { code: 'MS', name: 'Montserrat' },
    { code: 'MA', name: 'Morocco' },
    { code: 'MZ', name: 'Mozambique' },
    { code: 'MM', name: 'Myanmar' },
    { code: 'NA', name: 'Namibia' },
    { code: 'NR', name: 'Nauru' },
    { code: 'NP', name: 'Nepal' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NC', name: 'New Caledonia' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NI', name: 'Nicaragua' },
    { code: 'NE', name: 'Niger' },
    { code: 'NG', name: 'Nigeria' },
    { code: 'NU', name: 'Niue' },
    { code: 'NF', name: 'Norfolk Island' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'NO', name: 'Norway' },
    { code: 'OM', name: 'Oman' },
    { code: 'PK', name: 'Pakistan' },
    { code: 'PW', name: 'Palau' },
    { code: 'PS', name: 'Palestine, State of' },
    { code: 'PA', name: 'Panama' },
    { code: 'PG', name: 'Papua New Guinea' },
    { code: 'PY', name: 'Paraguay' },
    { code: 'PE', name: 'Peru' },
    { code: 'PH', name: 'Philippines' },
    { code: 'PN', name: 'Pitcairn' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'QA', name: 'Qatar' },
    { code: 'RE', name: 'R\u00e9union' },
    { code: 'RO', name: 'Romania' },
    { code: 'RU', name: 'Russian Federation' },
    { code: 'RW', name: 'Rwanda' },
    { code: 'BL', name: 'Saint Barth\u00e9lemy' },
    { code: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha' },
    { code: 'KN', name: 'Saint Kitts and Nevis' },
    { code: 'LC', name: 'Saint Lucia' },
    { code: 'MF', name: 'Saint Martin (French part)' },
    { code: 'PM', name: 'Saint Pierre and Miquelon' },
    { code: 'VC', name: 'Saint Vincent and the Grenadines' },
    { code: 'WS', name: 'Samoa' },
    { code: 'SM', name: 'San Marino' },
    { code: 'ST', name: 'Sao Tome and Principe' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SN', name: 'Senegal' },
    { code: 'RS', name: 'Serbia' },
    { code: 'SC', name: 'Seychelles' },
    { code: 'SL', name: 'Sierra Leone' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SX', name: 'Sint Maarten (Dutch part)' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'SB', name: 'Solomon Islands' },
    { code: 'SO', name: 'Somalia' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
    { code: 'SS', name: 'South Sudan' },
    { code: 'ES', name: 'Spain' },
    { code: 'LK', name: 'Sri Lanka' },
    { code: 'SD', name: 'Sudan' },
    { code: 'SR', name: 'Suriname' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen' },
    { code: 'SZ', name: 'Swaziland' },
    { code: 'SE', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'SY', name: 'Syrian Arab Republic' },
    { code: 'TW', name: 'Taiwan, Province of China' },
    { code: 'TJ', name: 'Tajikistan' },
    { code: 'TZ', name: 'Tanzania, United Republic of' },
    { code: 'TH', name: 'Thailand' },
    { code: 'TL', name: 'Timor-Leste' },
    { code: 'TG', name: 'Togo' },
    { code: 'TK', name: 'Tokelau' },
    { code: 'TO', name: 'Tonga' },
    { code: 'TT', name: 'Trinidad and Tobago' },
    { code: 'TN', name: 'Tunisia' },
    { code: 'TR', name: 'Turkey' },
    { code: 'TM', name: 'Turkmenistan' },
    { code: 'TC', name: 'Turks and Caicos Islands' },
    { code: 'TV', name: 'Tuvalu' },
    { code: 'UG', name: 'Uganda' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States' },
    { code: 'UM', name: 'United States Minor Outlying Islands' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'UZ', name: 'Uzbekistan' },
    { code: 'VU', name: 'Vanuatu' },
    { code: 'VE', name: 'Venezuela, Bolivarian Republic of' },
    { code: 'VN', name: 'Viet Nam' },
    { code: 'VG', name: 'Virgin Islands, British' },
    { code: 'VI', name: 'Virgin Islands, U.S.' },
    { code: 'WF', name: 'Wallis and Futuna' },
    { code: 'EH', name: 'Western Sahara' },
    { code: 'YE', name: 'Yemen' },
    { code: 'ZM', name: 'Zambia' },
    { code: 'ZW', name: 'Zimbabwe' },
];

export const DATA_STORE_STATUS = {
    success: 'SUCCESS',
    failure: 'FAILURE',
    timedOut: 'TIMED OUT',
    migrating: 'MIGRATING',
};

export const FLOW_LIBRARY_LAYOUTS = {
    LIST: 'list',
    GRID: 'grid',
};

export const RUNTIME_URI = `${window.location.protocol}//${window.location.host}`;

export const LOCAL_RUNTIME_VIEWS = {
    list: 'LIST_VIEW',
    edit: 'EDIT_VIEW',
    create: 'CREATE_VIEW',
};

// Regex pattern for characters that are hexadecimal (a-f, A-F, 0-9) in the pattern []{8}-[]{4}-[]{4}-[]{4}-[]{12}
export const REGEX_PATTERN_GUID =
    '[A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12}';
// Regex for characters that are hexadecimal (a-f, A-F, 0-9) in the pattern []{8}-[]{4}-[]{4}-[]{4}-[]{12}
export const REGEX_GUID = new RegExp(`^${REGEX_PATTERN_GUID}$`);
// Regex for characters that are NOT hexadecimal (a-f, A-F, 0-9) or dashes
export const REGEX_ILLEGAL_GUID = /[^A-Fa-f0-9-]/g;

// Regex pattern for characters in (a-z, A-Z, 0-9) and hyphens (-) and dots (.)
export const REGEX_PATTERN_TENANT_NAME = '[A-Za-z0-9-.]+';
// Regex for starts with @, then has only characters in (a-z, A-Z, 0-9) and hyphens (-) and dots (.)
export const REGEX_TENANT_NAME = new RegExp(`^@${REGEX_PATTERN_TENANT_NAME}$`);
// Regex for characters NOT in (a-z, A-Z, 0-9) and hyphens (-) and dots (.)
export const REGEX_ILLEGAL_TENANT_NAME = /[^A-Za-z0-9-.]/g;

/* Our current basic email regex:
 * [^@]+ Starts with a non-zero amount of characters that aren't '@'
 * @     Then has an '@'
 * [^.]+ Then has a non-zero amount of characters that aren't '.'
 * [.]   Then has a literal '.'
 * .+    Then has a non-zero amount of characters
 */
export const REGEX_PATTERN_EMAIL = '[^@]+@[^.]+[.].+';
export const REGEX_EMAIL = new RegExp(REGEX_PATTERN_EMAIL);
